import styled from "styled-components";
import BackgroundFooter from "../../assets/backgroundHeader.png"

export const ContainerStyle = styled.div`
    .background-header{
        position: relative;
        width: 100%;
        height: 100vh !important;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url(${BackgroundFooter});
    }

    .top{
        width: 100%;
        padding: 10px 0px 10px 0px;
        position: fixed;
        z-index: 3;
    }

    .top {
        background-color: transparent;
        transition: background-color 0.3s ease;
    }

    .top.scrolled {
        background-color: #007046;
    }

    .width90{
        display: flex;
        width: 90%;
        margin: 0 auto;
        align-items: center;
        justify-content: space-between;
    }

    img{
        height: 50px;
    }

    .div-ancoras{
        display: flex;
        gap: 20px;
    
        h4{
            color: #FFFFFF;
            font-weight: 400;
            font-size: 20px;
            padding: 20px 20px 0px 0px;
            /* position: relative;
            z-index: 6; */
        }

        h4:hover{
            font-weight: 600;
            cursor: pointer;
        }

        .border-right{
            display: none;
            border-right: 2px solid rgb(255, 255, 255);
        }
    }


    .div-titulo{
        display: flex;
        flex-direction: column;
        width: 100%;
        align-items: center;
        justify-content: center;
        height: calc(100% - 87px);
    }

    h1{
        width: 96%;
        max-width: 1500px;
        font-size: 45px;
        font-weight: 100;
        color: #FFFFFF;
        text-align: center;

        b{
            font-size: 45px;
            color: #FFFFFF;
            margin-right: 10px;
        }
    }

    .seta-baixo{
        width: max-content;
        height: 33px;
        cursor: pointer;
        border-radius: 100%;
        position: absolute;
        bottom: 80px;
        left: 50%;
        transform: translateX(-50%);

        svg{
            width: 35px;
            height: 30px;
        }
    }

    @media(min-width: 1100px){

        img{
            height: 40px;
        }
        .div-ancoras{

            h4{
                font-size: 18px;
                padding: 15px 20px 12px 0px;
            }
            
            .border-right{
                display: flex;
            }
        }

        h1{
            font-size: 80px;
            b{
                font-size: 80px;
                margin-right: 15px;
            }
        }
    }
`